var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgQuickGuide = function SvgQuickGuide(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16797 1.83301C4.16797 1.28072 4.61568 0.833008 5.16797 0.833008H24.8346C25.3869 0.833008 25.8346 1.28072 25.8346 1.83301V24.833C25.8346 25.3853 25.3869 25.833 24.8346 25.833H5.16797C4.61568 25.833 4.16797 25.3853 4.16797 24.833V1.83301ZM11.0012 16.8005V10.1995C11.0012 9.43703 11.8203 8.95506 12.4869 9.32536L18.4277 12.6258C19.1135 13.0068 19.1135 13.9932 18.4277 14.3742L12.4869 17.6746C11.8203 18.0449 11.0012 17.563 11.0012 16.8005ZM7.5013 28.1663V27.4997H26.5013C27.0536 27.4997 27.5013 27.052 27.5013 26.4997V3.33301H28.168C28.7203 3.33301 29.168 3.78072 29.168 4.33301V28.1663C29.168 28.7186 28.7203 29.1663 28.168 29.1663H8.5013C7.94902 29.1663 7.5013 28.7186 7.5013 28.1663Z",
    fill: "#0073BF",
    className: "fill"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 1.66699,
    width: 3.33333,
    height: 1.66667,
    fill: "white",
    className: "fill-inverted"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 23,
    width: 3.33333,
    height: 1.66667,
    fill: "white",
    className: "fill-inverted"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.332,
    y: 1.66699,
    width: 3.33333,
    height: 1.66667,
    fill: "white",
    className: "fill-inverted"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.332,
    y: 23,
    width: 3.33333,
    height: 1.66667,
    fill: "white",
    className: "fill-inverted"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.168,
    y: 1.66699,
    width: 3.33333,
    height: 1.66667,
    fill: "white",
    className: "fill-inverted"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19.168,
    y: 23,
    width: 3.33333,
    height: 1.66667,
    fill: "white",
    className: "fill-inverted"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuickGuide, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quick-guide.3a8bb714.svg";
export { ForwardRef as ReactComponent };